import axios from 'axios';
// import { createprops.history } from 'history';
import toastr from 'toastr';
import * as types from '../constants/actionTypes';
import * as api from '../tools/apiConfig';
// const props.history = createprops.history();
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import openSocket from "socket.io-client";
import * as url from "../tools/config";
let environment = process.env.REACT_APP_NODE_ENV ? process.env.REACT_APP_NODE_ENV : 'development'
const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);


export function getSpecializationList(props) {
	return function (dispatch, getState) {
		axios.get(api.GET_SPECIALIZATION_LIST, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					return dispatch({ type: types.DASH_GET_SPECIALIZATION_LIST, specializationList: response.data.data });
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
				else {
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {
			});
	}
}

export function getSpecialistList(data, props) {
	return function (dispatch, getState) {
		axios.post(api.GET_SPECIALISTS_LIST, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				
				if (response.data.code == 200) {
					if (data) {
						props.history.push('/dashboard/book-appointment');

						response.data.data.specialists = data.user;
						response.data.data.per_page = data.per_page;

						return dispatch({ type: types.GET_SPECIALISTS_LIST, specialistList: response.data.data, searchkey: data })
					}
				} else if (response.data.code == 402) {
					localStorage.clear();
					props.history.push('/');
					toastr.error(response.data.message);
				}
			})
			.catch(function (error) {
			});
	}
}

export function getAppointmentsCount(data) {

	return function (dispatch, getState) {
		axios.post(api.GET_APPOINTMENTS_COUNT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					if (data) {
						return dispatch({ type: types.GET_APPOINTMENTS_COUNT, appointmentsCount: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
			});
	}
}

export function logout(data, props) {
	return function (dispatch, getState) {

		axios.post(api.LOGOUT, data, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + localStorage.token
			}
		})
			.then(function (response) {
				let locality = localStorage.getItem('locality', locality)
				let localityState = localStorage.getItem('localityState', localityState)
				let localityCountry = localStorage.getItem('localityCountry', localityCountry)
				localStorage.clear();
				localStorage.setItem('locality', locality)
				localStorage.setItem('localityState', localityState)
				localStorage.setItem('localityCountry', localityCountry)
				if (response.data.code == 200) {
           socket.emit('disconnect_call', {
            userId:data.userId,
		      	notificationType: 'disconnect_call'
            }, function () { alert("here") });

					if (data) {
						var rolename = response.data.data.role.name;
						if(rolename=="Patient"){
							toast.info('User' +' '+ response.data.message);
						}else if(rolename=="Specialist"){
							toast.info('Specialist' +' '+ response.data.message);

						}

						navigator.geolocation.getCurrentPosition(
							function (position) { // success cb
								var lat = position.coords.latitude;
								var lng = position.coords.longitude;
								localStorage.setItem('lat', lat);
								localStorage.setItem('lng', lng);
							},
							function () { // fail cb
								localStorage.setItem('lat', 0);
								localStorage.setItem('lng', 0);
							}
						);
					
						
						localStorage.clear();
						props.history.push('/')

						return dispatch({ type: types.LOG_OUT, appointmentsCount: response.data.data })
					}
				} else if (response.data.code == 402) {
				}
			})
			.catch(function (error) {
			});
	}
}

export function searchingComplete() {
	return function (dispatch, getState) {
					return dispatch({ type: types.SEARCH_COMPLETE});
	}
}
